import { CompanyType } from '../enums/company-type';

/**
 * ECDEV-256: Single = the active company only, All = every company the user belongs to.
 *
 * Numeric, because the API serialises enums as numbers — `GET /personal/companies` returns
 * `scope: 0`, not `"Single"`. The JWT's `company.scope` claim is the string form, so compare that
 * one against {@link CompanyScopeClaim} instead.
 */
export enum CompanyScopeMode {
  Single = 0,
  All = 1,
}

/** The `company.scope` JWT claim values, which are the C# enum names rather than its numbers. */
export const CompanyScopeClaim = {
  Single: 'Single',
  All: 'All',
} as const;

export interface UserCompany {
  id: string;
  name: string;
  type: CompanyType;
  isDefault: boolean;
}

export interface CurrentUserCompanies {
  companies: UserCompany[];
  activeCompanyId: string | null;
  scope: CompanyScopeMode;

  /**
   * True only when the user belongs to more than one company. The switcher is hidden entirely
   * otherwise, so nothing changes for the ordinary single-company user.
   */
  canSelectAllCompanies: boolean;
}
